// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__lql_v","overflowing":"ReadFullNote_overflowing__8d8wj"};